exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.pad5[data-v-241bb12b]{padding:10px 0\n}\n.px-10[data-v-241bb12b]{padding:0 10px\n}\n", "", {"version":3,"sources":["/app/frontend/src/components/informacoesCadastro/common/ListagemDocumentos.vue"],"names":[],"mappings":";AA0FA,uBACE,cAAe;CAChB;AAAA,wBAEC,cAAe;CAChB","file":"ListagemDocumentos.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.pad5 {\n  padding: 10px 0;\n}\n.px-10 {\n  padding: 0 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-241bb12b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/informacoesCadastro/common/ListagemDocumentos.vue
// module id = hmAu
// module chunks = 11